import { WarningAmberRounded } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Typography,
} from "@mui/material";
import React from "react";
import { RoleList } from "../../model/admin_roles";
import { greyEnabled, purple, purpleLight, red, redLight, black } from "../../../../theme/colors";

interface Props {
  deleteRole: boolean;
  selectedRoleDetails: RoleList;
  deleteAdminRolesApiCall: () => void;
  setDeleteRole: (val: boolean) => void;
}

export default function DeleteRole({
  deleteRole,
  selectedRoleDetails,
  deleteAdminRolesApiCall,
  setDeleteRole,
}: Props) {
  return (
    <Dialog open={deleteRole} onClose={() => setDeleteRole(false)} PaperProps={{ sx: { borderRadius: 4 } }}>
      <DialogContent sx={{ width: 400, maxWidth: "90vw", p: 4, display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 56,
            height: 56,
            borderRadius: "50%",
            bgcolor: redLight,
            mb: 2,
          }}
        >
          <WarningAmberRounded sx={{ color: red, fontSize: 28 }} />
        </Box>
        <Typography variant="h6" fontWeight={700} color={black} textAlign="center">
          Delete this role?
        </Typography>
        <Typography variant="body2" color={greyEnabled} textAlign="center" mt={0.5}>
          {selectedRoleDetails?.role
            ? <>You're about to delete <strong>{selectedRoleDetails.role}</strong>. This action cannot be undone.</>
            : "This action cannot be undone."}
        </Typography>

        <Box display="flex" gap={1.5} width="100%" mt={4}>
          <Button
            fullWidth
            onClick={() => setDeleteRole(false)}
            variant="outlined"
            sx={{
              borderColor: purple,
              color: purple,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { borderColor: purple, bgcolor: purpleLight },
            }}
          >
            Cancel
          </Button>
          <Button
            fullWidth
            onClick={() => deleteAdminRolesApiCall?.()}
            variant="contained"
            disableElevation
            sx={{
              bgcolor: purple,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { bgcolor: "#7A2074" },
            }}
          >
            Delete
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
